import React, { useState } from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import StudentMessagesPopup from "../../../../student/pages/home/messagesPopup/MessagesPopup";
import TeacherMessagesPopup from "../../../../teacher/pages/home/messagesPopup/MessagesPopup";
import messagesImg from "../../../../assests/carouselWidget/message.png";
import classes from "./MessagesCarouselWidget.module.css";

const MessagesCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const { isStudent } = useSelector(state => state.auth);
    const [messagesPopupOpen, setMessagesPopupOpen] = useState(false);
    const MessagesPopup = isStudent ? StudentMessagesPopup : TeacherMessagesPopup;

    const openMessagesPopup = (e) => {
        e?.stopPropagation();
        setMessagesPopupOpen(true);
    };

    return (
        <>
            <WidgetCarouselCard
                color="#BBA9E0"
                title={texts.messagesBoard}
                image={messagesImg}
                imageAlt={texts.messagesBoard}
                onClick={openMessagesPopup}
                className={isStudent ? undefined : classes.MessagesCarouselWidget}
            />
            {messagesPopupOpen && <MessagesPopup onClose={() => setMessagesPopupOpen(false)} />}
        </>
    );
};

export default MessagesCarouselWidget;
